module.exports = __webpack_public_path__ + "media/images/countrysquared/kh-2a7ec074c1e89f7a916745911b7ef028.svg";